import {
  search,
} from '@/api/constant';
import * as mutations from './mutations';
import * as actions from './actions';

const CONSTANT_TYPE_CUSTOMER_TYPE = 'CUSTOMER_TYPE';
const CONSTANT_TYPE_PARTNER_TYPE = 'PARTNER_TYPE';
const CONSTANT_TYPE_PARTNER_STATUS = 'PARTNER_STATUS';
const CONSTANT_TYPE_SOCIAL_MEDIA = 'SOCIAL_MEDIA';
const CONSTANT_TYPE_SOCIAL_MEDIA_CONTENT_TYPE = 'SOCIAL_MEDIA_CONTENT_TYPE';

const CONSTANT_TYPE_STATE_FIELD_KEY_MAP = {
  [CONSTANT_TYPE_CUSTOMER_TYPE]: 'customerTypes',
  [CONSTANT_TYPE_PARTNER_TYPE]: 'partnerTypes',
  [CONSTANT_TYPE_PARTNER_STATUS]: 'partnerStatuses',
  [CONSTANT_TYPE_SOCIAL_MEDIA]: 'socialMedias',
  [CONSTANT_TYPE_SOCIAL_MEDIA_CONTENT_TYPE]: 'socialMediaContentTypes',
};

const initialState = () => {
  const state = {};

  Object.values(CONSTANT_TYPE_STATE_FIELD_KEY_MAP).forEach((stateFieldKey) => {
    state[stateFieldKey] = [];
  });

  return state;
};

export default {
  namespaced: true,
  state: () => initialState(),
  mutations: {
    [mutations.RESET_STATE](state) {
      Object.assign(state, initialState());
    },

    [mutations.SET_CONSTANTS](state, constants) {
      constants.forEach((constant) => {
        if (!constant.typeName) {
          throw new Error('Unknown constant type');
        }

        if (CONSTANT_TYPE_STATE_FIELD_KEY_MAP[constant.typeName]) {
          state[CONSTANT_TYPE_STATE_FIELD_KEY_MAP[constant.typeName]].push(constant);
        }
      });
    },
  },

  getters: {
    userTypes: (state) => {
      const userTypes = [...state.partnerTypes.map((item) => ({ ...item, isCustomerType: false }))];

      userTypes.push(...state.customerTypes.map((customerType) => ({
        ...customerType,
        isCustomerType: true,
      })));
      userTypes.sort((a, b) => a.value.localeCompare(b.value, 'en', { sensitivity: 'base' }));

      return userTypes;
    },
  },

  actions: {
    async [actions.LOAD_CONSTANTS](context) {
      const response = await search();
      const isSuccess = response.data && response.status === 200;

      if (isSuccess) {
        context.commit(mutations.RESET_STATE);
        context.commit(mutations.SET_CONSTANTS, response.data);
      }

      return isSuccess;
    },
  },
};
